<template>

    <div class="outer-wrapper">

        <div class="title">

            <h1>Clear Data</h1>
        </div>
        <button type="button" class="button btn-aqua" @click=" clearDb() ">Empty Local DB</button>
    </div>
</template>

<script>

    import { mapActions } from 'vuex';

    export default {

        name: 'clear-db',
        methods: {

            ...mapActions({

                clearDb: 'clearIndexDb'
            })
        }
    }
</script>

<style scoped>

    .outer-wrapper{

        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }

    .title{

        width: 100%;
        text-align: left;
        color: #444;
        box-shadow: 0px 3px 4px -3px #999;
        margin-bottom: 15px;
    }
    button{

        width: 155px;
        height: 60px;
        margin: 10px 0;
    }
</style>